import React from "react";
import Lottie from "lottie-react";
import arrowIcon from "../assets/images/Vector_btn.png";
import bkgAzzurro from "../assets/images/bkg-azzurro.svg";
import TimelineLottie from "../assets/json/sezione-03-2-img-01.json";

// Eventi in ordine cronologico; "pos" = sopra/sotto la linea (desktop)
const EVENTI = [
  { data: "", titolo: "Progressiva estensione della Certificazione per la parità di genere", pos: "below" },
  { data: "05.02", titolo: "Premio Mutualità", pos: "above" },
  { data: "21.02", titolo: "Rating di solidità finanziaria", pos: "below" },
  { data: "17.04", titolo: "Partnership Banco Desio - Italiana Assicurazioni", pos: "above" },
  { data: "09.05", titolo: "25 anni di Banca Reale", pos: "below" },
  { data: "17.06", titolo: "Conferimento a Reale International della partecipazione detenuta da Reale Mutua in Ydrogios", pos: "above" },
  { data: "29.10", titolo: "Partnership Banca Popolare Alto Adige - Italiana Assicurazioni", pos: "below" },
  { data: "01.12", titolo: "Accordo Finint Private Bank - Italiana Assicurazioni", pos: "above" },
  { data: "01.12", titolo: "Certificazione di Great Place to Work® per Reale Group", pos: "below" },
  { data: "31.12", titolo: "Rilevazione Net Promoter Score", pos: "above" },
];

const NAVY = "#002655";
const RING = "#3a52a0";

// Pallino ad anello
const Dot = () => (
  <div
    className="w-7 h-7 rounded-full bg-white border-[4px] flex-shrink-0"
    style={{ borderColor: RING, boxShadow: `0 0 0 2px ${NAVY}` }}
  />
);

export default function SezioneEventi() {
  return (
    <section
      id="sezione-eventi"
      className="w-full py-12 md:py-16 bg-[#dceef9]"
      style={{ backgroundImage: `url(${bkgAzzurro})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}
    >
      <div className="mx-auto xl:w-[1440px] px-5 xl:px-0">
        <h2 className="text-center mb-8 md:mb-10" style={{ color: NAVY }}>
          Principali eventi dell&rsquo;esercizio
        </h2>

        {/* ---------- DESKTOP: timeline orizzontale alternata ---------- */}
        <div className="hidden md:block relative">
          {/* Illustrazione Lottie + "2025" (assoluta, sborda a sinistra) */}
          <div className="absolute left-0 -bottom-[130px] w-[22%] pointer-events-none select-none">
            <Lottie animationData={TimelineLottie} loop autoplay style={{ width: "100%", height: "auto" }} />
            <span className="absolute top-[2%] left-[65%] font-bold text-[#002655] text-[28px] xl:text-[40px] leading-none">
              2025
            </span>
          </div>

          {/* Eventi (scroll orizzontale su tablet per evitare il break) */}
          <div className="overflow-x-auto overscroll-x-contain">
            <div className="flex pl-[20%] min-w-[1280px]">
            {EVENTI.map((e, i) => (
              <div key={i} className="flex-1 flex flex-col items-center">
                {/* slot SOPRA */}
                <div className="h-[240px] w-full flex flex-col justify-end items-start text-left px-1">
                  {e.pos === "above" && (
                    <>
                      <div className="text-[16px] xl:text-[18px] leading-tight font-bold" style={{ color: NAVY }}>
                        {e.titolo}
                      </div>
                      <div className="text-[22px] xl:text-[26px] font-bold mt-3" style={{ color: NAVY }}>
                        {e.data}
                      </div>
                      <div className="w-[2px] h-6 mt-2 ml-[9px]" style={{ background: NAVY }} />
                    </>
                  )}
                </div>

                {/* pallino sulla linea */}
                <div className="relative w-full flex justify-start">
                  <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 h-[2px]" style={{ background: NAVY }} />
                  <div className="relative">
                    <Dot />
                  </div>
                </div>

                {/* slot SOTTO */}
                <div className="h-[230px] w-full flex flex-col justify-start items-start text-left px-1">
                  {e.pos === "below" && (
                    <>
                      <div className="w-[2px] h-6 mb-2 ml-[9px]" style={{ background: NAVY }} />
                      {e.data && (
                        <div className="text-[22px] xl:text-[26px] font-bold" style={{ color: NAVY }}>
                          {e.data}
                        </div>
                      )}
                      <div className="text-[16px] xl:text-[18px] leading-tight font-bold mt-2" style={{ color: NAVY }}>
                        {e.titolo}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>

        {/* ---------- MOBILE: timeline verticale (senza illustrazione) ---------- */}
        <div className="md:hidden flex flex-col">
          <div className="w-full flex flex-col">
            {EVENTI.map((e, i) => (
              <div key={i} className="flex gap-4">
                {/* linea verticale + pallino */}
                <div className="flex flex-col items-center">
                  <Dot />
                  {i < EVENTI.length - 1 && (
                    <div className="w-[2px] flex-1 my-1" style={{ background: NAVY }} />
                  )}
                </div>
                {/* contenuto */}
                <div className="pb-8">
                  {e.data && (
                    <div className="text-[26px] font-bold leading-none" style={{ color: NAVY }}>
                      {e.data}
                    </div>
                  )}
                  <div className="text-[18px] font-bold leading-snug mt-1" style={{ color: NAVY }}>
                    {e.titolo}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottone Consulta il Report */}
        <div className="flex justify-center mt-8 md:mt-6">
          <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=19" target="_blank">
          <button type="button" className="bt-secondary flex items-center gap-2">
            <img src={arrowIcon} alt="" className="w-[22px] h-[22px]" />
            Consulta il Report - cap.1 par.1.1.3.2
          </button>
          </a>
        </div>
      </div>
    </section>
  );
}
